import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Glide from "@glidejs/glide";
import { DocumentContext } from "~context/DocumentContext";

const Carousel = ({
  autoPlay,
  className,
  items,
  keyPrefix,
  onUpdate,
  peek,
  perView,
  withBullets
}) => {
  const { windowWidth } = useContext(DocumentContext);

  const glideRef = useRef();

  const [activeIndex, setActiveIndex] = useState(0);
  const [glide, setGlide] = useState(null);

  //

  // useEffect(() => {
  // TODO : stop memory leak
  // }, []);

  useEffect(() => {
    if (!glideRef?.current || !windowWidth || glide) {
      return;
    }

    const glideCarousel = new Glide(`#${keyPrefix}-glide`, {
      autoPlay: autoPlay <= 0 ? false : autoPlay,
      bound: perView !== 1,
      gap: 0,
      hoverpause: true,
      peek,
      perView,
      rewind: false,
      type: `carousel`
    });

    glideCarousel.on(`run`, () => {
      setActiveIndex(glideCarousel.index);

      onUpdate(glideCarousel.index);
    });

    glideCarousel.mount();

    setGlide(glideCarousel);
  }, [glideRef, windowWidth]);

  //

  return (
    <section
      key={`${keyPrefix}-container`}
      className={`carousel ${className ||
        `w-full relative`} flex items-center justify-center overflow-x-hidden`}
    >
      <div className="carousel__glide w-full relative block">
        <div id={`${keyPrefix}-glide`} ref={glideRef} className="glide">
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              {items.map((itemJSX, itemIndex) => {
                const key = `${keyPrefix}-item-${itemIndex}`;

                return (
                  <li key={key} className="glide__slide relative">
                    {itemJSX}
                  </li>
                );
              })}
            </ul>
          </div>

          {withBullets && (
            <div
              className="glide__bullets absolute bottom-0 left-0 right-0 mb-6 flex items-center justify-center"
              data-glide-el="controls[nav]"
            >
              {items.map((_, itemIndex) => {
                const bulletKey = `${keyPrefix}-bullet-${itemIndex}`;

                if (perView !== 1 && itemIndex === items.length - 1) {
                  return <></>;
                }

                return (
                  <button
                    key={bulletKey}
                    type="button"
                    className={`glide__bullet mr-v05 ml-v05 ${
                      activeIndex === itemIndex ? `bg-black` : `bg-white`
                    }`}
                    data-glide-dir={`=${itemIndex}`}
                  ></button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

Carousel.defaultProps = {
  autoPlay: 0,
  className: ``,
  keyPrefix: `glide-carousel`,
  onUpdate: () => {},
  peek: 0,
  perView: 1,
  withBullets: false
};

Carousel.propTypes = {
  autoPlay: PropTypes.number,
  className: PropTypes.string,
  items: PropTypes.node.isRequired,
  keyPrefix: PropTypes.string,
  onUpdate: PropTypes.func,
  peek: PropTypes.number,
  perView: PropTypes.number,
  withBullets: PropTypes.bool
};

export default Carousel;
